<template>
  <div class="form-group row">
    <div class="col-md-3 col-xl-3">
      <label class="label-horizontal">{{$t('dashboard.leverage')}}</label>
    </div>
    <div class="col-md-9 col-xl-9">
      <div class="row">
        <div class="col-xl-7">
          <span class="iban">1:{{account.leverage}}</span>
        </div>
        <div class="space-10 visible-xs visible-sm visible-md visible-lg"></div>
        <div class="col-xl-5">
          <span class="status"><i class="fa fa-check-circle"></i>{{$t('dashboard.status_list[1]')}}</span>
        </div>
      </div>
    </div>
  </div>
</template>


<script>


  import EventBus from '../event-bus';
  import { getUserRecord } from '../services/MT4Service';
  import AccountService from '@/services/AccountService';

  let accountService = new AccountService();

  export default {
    name: 'mt4-account-details',
    data: function () {
      return {
        account: { accountType : {}},
        isLoading: true
      };
    },
    created() {
      EventBus.$on('onUpdateComponent', (r)=>{
          this.populateComponent();
      });
      this.populateComponent();
    },
    methods: {
      populateComponent() {
          let t = this;
          t.isLoading = true;        
          accountService.getDefaultMt4Account().then(r => {
            t.account = r.data;
            t.isLoading = false;         
          });
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/MT4AccountDetails.vue